export const COUNTRYLIST = "countryList";
export const SET_COUNTRY = "setCountry";
export const SET_SOURCE_COUNTRY = "setSourceCountry";
export const SOURCE_COUNTRY = "sourceCountry";

//Auth
export const USER_LOGIN = "userLogin";
export const ENTRA_ID_LOGIN = "entraIdLogin";
export const HANDLE_REDIRECT = "handleRedirect";
export const UNIFIED_LOGOUT = "unifiedLogout";
export const REFRESH_TOKEN = "refreshToken";
export const VALIDATE_AUTH = "validateAuth";

//Customer
export const GET_CUSTOMER_LIST = "getCustomerlist";
export const GET_CUSTOMER_INFO = "getCustomerinfo";
export const GET_CUSTOMER_DETAILS = "getCustomerDetails";
export const GET_CUSTOMER_ACCOUNT_DETAILS = "getCustomerAccountDetails";
export const GET_CUSTOMER_IDENTIFICATIONS = "getCustomerIdentifications";
export const CUSTOMER_REMITER_GROUPS = "customerRemiterGroups";
export const GET_ACCOUNT_STATUS_LIST = "getAccountStatusList";
export const UPDATE_CUSTOMER_PERSONAL_DETAILS = "updateCustomerPersonalDetails";
export const GET_CUSTOMER_ADDRESS = "getCustomerAddress";
export const UPDATE_CUSTOMER_ADDRESS = "updateCustomerAddress";
export const FRESH_CUSTOMER_LIST = "freshCustomerList";
export const CUSTOMER_CARD_LIST = "customerCardList";
export const GET_CUSTOMER_IDSCAN = "customerIdScan";
export const GET_CUSTOMER_IDIMAGES = "customerIdImages";
export const ID_TYPE_LIST = "customerIdTypeList";
export const GET_CUSTOMER_OTHER_DETAILS = "getCustomerOtherDetails";
export const UPDATE_CUSTOMER_OTHER_DETAILS = "updateCustomerOtherDetails";
export const GET_CUSTOMER_COMMENTS = "getCustomerComments";
export const POST_CUSTOMER_COMMENT = "postCustomerComment";
export const UPDATE_CUSTOMER_COMMENT = "updateCustomerComment";
export const GET_CUSTOMER_ACTIVITY_LOGS = "getCustomerActivityLogs";
export const GET_CUSTOMER_UPLOADED_DOCUMENTS = "getCustomerUploadedDocuments";
export const UPDATE_CUSTOMER_DOCUMENT_STATUS = "updateCustomerDocumentStatus";
export const GET_CUSTOMER_UPLOADED_ID_DOCUMENTS =
  "getCustomerUploadedIdDocuments";
export const RESET_CUSTOMER_PASSWORD = "resetCustomerPassword";
export const CREATE_CUSTOMER_IDENTIFICATION = "createCustomerIdentification";
export const UPDATE_CUSTOMER_IDENTIFICATION = "updateCustomerIdentification";
export const UPDATE_CUSTOMER_VERIFICATION = "updateCustomerVerification";
export const RESET_ID_SCAN_ATTEMPTS = "resetIdScanAttempts";
export const GET_LOGIN_LOCKOUT_STATUS = "getLoginLockoutStatus";
export const UNLOCK_CUSTOMER_LOGIN = "unlockCustomerLogin";
export const LOCK_CUSTOMER_LOGIN = "lockCustomerLogin";
export const GET_CUSTOMER_DEVICES = "getCustomerDevices";
export const TRUST_CUSTOMER_DEVICE = "trustCustomerDevice";
export const REVOKE_CUSTOMER_DEVICE = "revokeCustomerDevice";
export const GET_REMITTER_CREDIT = "getRimetterCredit";
export const GET_REMITTER_WALLET_LIST = "getRemitterWalletlist";
export const GET_WALLET_HISTORY = "getWalletHistory";
export const GET_WALLET_CREDIT_TYPE_LIST = "getWalletcredittype";
export const POST_CUSTOMER_CREDIT = "postCustomerCredit";
export const UPDATE_CUSTOMER_CREDIT = "updateCustomercredit";
export const DELETE_CUSTOMER_CREDIT = "deleteCustomerCredit";
export const GET_LINKED_RISK_BATCH = "getLinkedRiskBatch";
export const GET_LINKED_RISK_EVIDENCE = "getLinkedRiskEvidence";
export const GET_ID_REVERIFICATION_CONFIG = "getIdReverificationConfig";
export const UPDATE_ID_REVERIFICATION_CONFIG = "updateIdReverificationConfig";
export const VERIFY_IDSCAN_JOURNEY = "verifyIdScanJourney";
export const APPROVE_IDSCAN_JOURNEY = "approveIdScanJourney";

//Notifications
export const GET_NOTIFICATION_TYPES = "getNotificationTypes";
export const GET_NOTIFICATION_ACTIONS = "getNotificationActions";
export const GET_NOTIFICATION_TEMPLATES = "getNotificationTemplates";
export const SEND_REMITTER_NOTIFICATION = "sendRemitterNotification";
export const GET_REMITTER_NOTIFICATION_LOGS = "getRemitterNotificationLogs";

//Bank
export const GET_BANKLIST = "getBanklist";
export const GET_BANK_BRANCHLIST_BYBANK = "getBankBranchlist";
export const GET_BANKACCOUNTS = "getBankAccounts";
export const GET_BANKACCOUNT_DETAILS = "getBankAccountDetailsById";
export const UPDATE_BANKACCOUNT_DETALS = "updateBankDetails";
export const DELETE_BENEFICIARY_BANKACCOUNT = "deleteBeneficiaryBankAccount";
export const GET_CUSTOMERS_BY_BANKACCOUNT = "getCustomersbyBankAccounts";

// Mobile Networks
export const GET_MOMOACCOUNTS = "getmomoAccounts";
export const GET_MOBILE_NETWORKS = "getMobileNetworks";
export const ADD_MOBILE_NETWORKS = "addMobileNetworks";
export const UPDATE_MOBILE_NETWORKS = "updateMobileNetworks";
export const GET_MOBILE_MONEY_BY_ID = "getMobileMoneyDetailsById";
export const DELETE_BENEFICIARY_MOBILE_MONEY =
  "deleteBeneficiaryMobileNetworks";
export const GET_CUSTOMERS_BY_MOMOWALLET = "getCustomersbyMOMOWallets";

//Beneficiary
export const GET_ALLBENEFICIARY_LIST = "getAllBeneficiarylist";
export const GET_BENEFICIARY_DETAILS = "getBeneficiaryDetails";
export const UPDATE_BENEFICIARY = "updateBeneficiary";
export const GET_BENEFICIARY_RELATIONSHIPS = "getBeneficiaryrelationships";
export const GET_LINKED_REMITTERS = "getLinkedRemitters";
// Beneficiary blacklist (block/unblock)
export const BLOCK_RECEIVER_RELATIONSHIP = "blockReceiverRelationship";
export const UNBLOCK_RECEIVER_RELATIONSHIP = "unblockReceiverRelationship";
export const BLOCK_RECEIVER_MOMO = "blockReceiverMomo";
export const UNBLOCK_RECEIVER_MOMO = "unblockReceiverMomo";
export const BLOCK_RECEIVER_BANK = "blockReceiverBank";
export const UNBLOCK_RECEIVER_BANK = "unblockReceiverBank";
export const GET_RECEIVER_LIST = "getReceiverList";
export const GET_RECEIVER_RISK_BATCH = "getReceiverRiskBatch";
export const GET_RECEIVER_RISK_EVIDENCE = "getReceiverRiskEvidence";
export const GET_RECEIVER_REMITTER_SIGNALS = "getReceiverRemitterSignals";
//partner
export const GET_PARTNER_LIST = "getPartnerList";

// Transactions
export const GET_TRANSACTION_LIST = "gettransactionList";
export const GET_PROVIDER_LIST = "getProviderList";
export const GET_TRANSACTION_REMITTER_RECEIVER_DETAILS = "getTransactionRemitterReceiverDetails";
export const GET_TRANSACTION_PAYMENT_DETAILS = "getTransactionPaymentDetails";
export const GET_WALLET_LEGIT = "getWalletLegit";
export const GET_TRANSACTION_PAYOUT_DETAILS = "getTransactionPayoutDetails";
export const GET_TRANSACTION_PROVIDER_RESPONSE = "getTransactionProviderResponse";
export const GET_PAYOUT_ATTEMPTS = "getPayoutAttempts";
export const GET_TRANSACTION_COMMENTS = "gettransactionComments";
export const POST_TRANSACTION_COMMENT = "postTransactionComment";
export const UPDATE_TRANSACTION_COMMENT = "updateTransactionComment";
export const GET_TRANSACTION_PAYMENTS_LOGS = "gettransactionPaymentsLog";
export const PROCESS_TRANSACTIONS = "processTransactions";
export const GET_TRANSACTION_STATUS = "getTransactionstatus";
export const UPDATE_TRANSACTION_STATUS = "updatetransactionstatus";
export const MANUAL_SUCCESS_TRANSACTION = "manualSuccessTransaction";
export const MANUAL_FAIL_TRANSACTION = "manualFailTransaction";
export const UPDATE_PAYOUT_STATUS = "updatepayoutstatus";
export const TRANSACTION_PAYMENT_CAPTURE = "transactionPaymentCapture";
export const RECONCILE_PAYMENT_STATUS = "reconcilePaymentStatus";
export const CHECK_TRANSACTION_STATUS = "checkTransactionStatus";
export const TRANSACTION_MOMO_NETWORKS = "transactionMomoNetworks";
export const UPDATE_TRANSACTION_MOMO_NUMBER = "updateTransactionMomoNumber";
export const TRANSACTION_BANK_LIST = "transactionBankList";
export const UPDATE_TRANSACTION_BANK_ACCOUNT = "updateTransactionBankAccount";
export const GET_NAME_FROM_NAMECHECK = "getNameFromNamecheck";
export const NAME_CHECK_PROPOSED_ACCOUNT = "nameCheckProposedAccount";
export const UPDATE_RECEIVER_NAME = "updateReceiverName";
export const GET_TRANSACTION_MOMO_BANK_DETAIL = "getTransactionMomoBankDetail";
export const UPDATE_TRANSACTION_BANK_MOMO_DETAILS = "updateTransactionBankMomoDetails";
export const SUBMIT_RECOVERY_ACTION = "submitRecoveryAction";

// Business
export const GET_BUSINESS_LIST = "getBusinessList";
export const UPDATE_BUSINESS_STATUS = "updateBusinessStatus";
export const DELETE_BUSINESS = "deleteBusiness";
export const GET_BUSINESS_OVERVIEW = "getBusinessOverview";
export const GET_BUSINESS_TRANSACTIONS = "getBusinessTransactions";
export const GET_BUSINESS_TRANSACTION_DETAIL = "getBusinessTransactionDetail";
export const EXPORT_BUSINESS_TRANSACTIONS = "exportBusinessTransactions";

// RoleMenu
export const GET_ROLE_LIST = "getUserRoleList";
export const POST_ROLE = "postUserRole";
export const UPDATE_ROLE = "updateUserRole";
export const GET_ROLE_WISE_MENU_LIST = "getRoleWiseMenuList";
export const CREATE_ROLE_WISE_MENU = "createRoleWiseMenu";
export const GET_MENU_LIST = "getMenuList";
export const GET_ROLE_WISE_PERMISSION_LIST = "getRoleWisePermissionList";
export const GET_ALL_PERMISSION = "getAllPermission";
export const UPDATE_PERMISSION = "updatePermission";

// Internal User
export const UPDATE_INTERNAL_USER_HQ_TX = "updateInternalUserHqTx";

// Bin
export const GET_BIN_LIST = "getBinList";
export const DOWNLOAD_BIN_LIST = "downloadBinList";
export const POST_BIN = "postBin";
export const GET_BIN_DETAILS = "getBinDetails";
export const UPDATE_BIN = "updateBin";
export const DELETE_BIN = "deleteBin";

// IP Blocklist
export const GET_IP_BLOCKLIST = "getIpBlocklist";
export const POST_IP_BLOCKLIST = "postIpBlocklist";
export const GET_IP_BLOCKLIST_DETAILS = "getIpBlocklistDetails";
export const UPDATE_IP_BLOCKLIST = "updateIpBlocklist";
export const DELETE_IP_BLOCKLIST = "deleteIpBlocklist";

// Offers
export const GET_OFFERS_LIST = "getOffersList";
export const GET_OFFER_DETAILS = "getOfferDetails";
export const CREATE_OFFER = "createOffer";
export const UPDATE_OFFER = "updateOffer";
export const DELETE_OFFER = "deleteOffer";

// Payment Methods
export const GET_ALL_PAYMENT_METHODS = "getAllPaymentMethods";

// Blocked Entities
export const GET_BLOCKED_ENTITIES = "getBlockedEntities";

// Reroute
export const GET_CHECKER_LIST = "getCheckerList";
export const UPDATE_CHECKER = "updateCheckerStatus";

// Name check (standalone header tool)
export const GET_NAMECHECK_INSTITUTIONS = "getNamecheckInstitutions";
export const RUN_NAMECHECK = "runNamecheck";